import { render, staticRenderFns } from "./NumberCard.vue?vue&type=template&id=44c9a831&scoped=true"
import script from "./NumberCard.vue?vue&type=script&lang=js"
export * from "./NumberCard.vue?vue&type=script&lang=js"
import style0 from "./NumberCard.vue?vue&type=style&index=0&id=44c9a831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c9a831",
  null
  
)

export default component.exports